import React from "react";
import { mergeStyles } from "@fluentui/merge-styles";
import { MessageBar, MessageBarBody, Button } from "@fluentui/react-components";

type Props = {
  onBtnClick: () => void;
  btnTitle: string;
  title: string;
};

const wrapperClass = mergeStyles({
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
});

const messageWrapper = mergeStyles({
  marginBottom: 20,
});

const LoginView: React.FC<Props> = (props) => {
  const { onBtnClick, title } = props;

  return (
    <div className={wrapperClass}>
      <div className={messageWrapper}>
        <MessageBar intent="warning">
          <MessageBarBody>{title}</MessageBarBody>
        </MessageBar>
      </div>
      <Button appearance="primary" onClick={() => { onBtnClick(); }}>
        Login
      </Button>
    </div>
  );
};

export default LoginView;
